import { ledgerType } from '@libs/enums';
import type { LedgerType } from '@libs/enums';
import { FieldSet, useItemName, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import type { OptionProps } from '@ps-smart-cp/ppfw-client';
import { customFieldLedgerSettingFieldConfig } from '../item-config';
import type { CustomFieldLedgerSettingDetail } from '../models';
import { CustomFieldLedgerSettingRow } from './CustomFieldLedgerSettingRow';

interface CustomFieldLedgerSettingFieldSetProps {
  ledger: LedgerType;
  selectBoxOptions: OptionProps[];
  setSettings: (setting: CustomFieldLedgerSettingDetail[]) => void;
  settingDetails: CustomFieldLedgerSettingDetail[];
  errorFields?: string[];
}

// TODO: カスタムフィールドの名称が全角28字以上で表示が崩れる問題の解決
// TODO: カスタムフィールド設定のstyled-component対応(https://proship-infra.atlassian.net/browse/AFW-326)
function CustomFieldLedgerFieldSet({
  ledger,
  settingDetails,
  setSettings,
  selectBoxOptions,
  errorFields,
}: CustomFieldLedgerSettingFieldSetProps) {
  const getName = useItemName();
  const { locale } = useLocalizedContents();

  return (
    <FieldSet
      legendProps={{
        title: ledgerType.toDisplay(ledger, locale),
        id: 'custom-field-ledger-connection-setting-field-set',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 400px repeat(2, 1fr) 2fr',
          gridTemplateRows: '26px repeat(3, 27px)',
        }}
      >
        <div style={{ display: 'contents' }}>
          <div style={{ gridArea: '1/1', textAlign: 'center' }}>
            {getName(customFieldLedgerSettingFieldConfig.displayOrder)}
          </div>
          <div style={{ gridArea: '1/2', textAlign: 'center' }}>
            {getName(customFieldLedgerSettingFieldConfig.customField)}
          </div>
          <div style={{ gridArea: '1/3', textAlign: 'center' }}>
            {getName(customFieldLedgerSettingFieldConfig.isRequired)}
          </div>
        </div>
        {settingDetails.map((row) => {
          return (
            <CustomFieldLedgerSettingRow
              settingDetail={row}
              setSettingDetail={(changed) =>
                setSettings(
                  settingDetails.map((checkRow) => {
                    if (checkRow.displayOrder < row.displayOrder) {
                      return checkRow;
                    } else if (checkRow.displayOrder === row.displayOrder) {
                      if (changed.customField === '') {
                        return { ...changed, isRequired: false };
                      } else {
                        return changed;
                      }
                    } else if (changed.customField !== '') {
                      return checkRow;
                    } else {
                      return { ...checkRow, customField: '', isRequired: false };
                    }
                  }),
                )
              }
              ledger={ledger}
              displayOrder={row.displayOrder}
              selectBoxOptions={selectBoxOptions}
              key={row.displayOrder}
              errorFields={errorFields}
              previousDisabled={
                row.displayOrder === 1
                  ? false
                  : settingDetails.find((detail) => detail.displayOrder === row.displayOrder - 1)
                      ?.customField === ''
              }
            />
          );
        })}
        <div style={{ gridColumn: '4', gridRow: '1/4' }}></div>
      </div>
    </FieldSet>
  );
}

export { CustomFieldLedgerFieldSet };
export type { CustomFieldLedgerSettingFieldSetProps };
